import * as z$1 from "zod/v4";
//#region src/schemas/protocol/execution-context.ts
const reference = z$1.string().trim().min(1).max(2048);
const executionContextAccessSchema = z$1.enum([
	"space_context",
	"read_only",
	"workspace"
]);
const workspace = z$1.enum(["current", "isolated"]);
const preferences = {
	access: executionContextAccessSchema.optional(),
	workspace: workspace.optional()
};
const executionContextSelectionSchema = z$1.discriminatedUnion("mode", [
	z$1.strictObject({
		mode: z$1.literal("auto"),
		...preferences
	}),
	z$1.strictObject({
		mode: z$1.literal("new"),
		...preferences
	}),
	z$1.strictObject({
		mode: z$1.literal("resume"),
		sourceWakeId: reference
	}),
	z$1.strictObject({
		mode: z$1.literal("fork"),
		sourceWakeId: reference,
		...preferences
	})
]);
const executionContextScopeSchema = z$1.strictObject({
	organizationId: reference,
	requesterProfileId: reference,
	spaceId: reference,
	targetProfileId: reference,
	threadId: reference.nullable()
});
const executionContextRequestSchema = z$1.strictObject({
	required: z$1.boolean().optional(),
	scope: executionContextScopeSchema,
	selection: executionContextSelectionSchema
});
const executionContextAssignmentSchema = z$1.strictObject({
	version: z$1.literal(1),
	id: z$1.string().uuid(),
	scope: executionContextScopeSchema,
	access: executionContextAccessSchema,
	workspace,
	forkSource: z$1.strictObject({
		contextId: z$1.string().uuid(),
		sourceWakeId: reference,
		nativeConversationId: reference,
		completedHistoryId: reference.optional(),
		runtimeWorkspaceFingerprint: reference,
		workspace
	}).optional()
});
const executionContextCompletionSchema = z$1.strictObject({
	contextId: z$1.string().uuid(),
	nativeConversationId: reference,
	runtimeWorkspaceFingerprint: reference,
	completedHistoryId: reference.optional()
});
const executionContextLegacyAssociationSchema = z$1.strictObject({
	id: reference,
	bindingId: reference,
	configurationRevision: z$1.number().int().positive(),
	agentControllerRef: reference,
	openMeldServiceRuntimeId: reference,
	nativeConversationId: reference.nullable(),
	scope: z$1.literal("legacy_unclassified")
});
const executionContextTaskSchema = executionContextAssignmentSchema.extend({
	legacyAssociation: executionContextLegacyAssociationSchema.optional(),
	nativeConversationId: reference.nullable(),
	runtimeWorkspaceFingerprint: reference.nullable()
});
//#endregion
export { executionContextAccessSchema, executionContextAssignmentSchema, executionContextCompletionSchema, executionContextLegacyAssociationSchema, executionContextRequestSchema, executionContextScopeSchema, executionContextSelectionSchema, executionContextTaskSchema };

//# sourceMappingURL=execution-context.js.map